import type { HermesApiTyped } from './types';

import './setup';
import { hermesApiRoot } from './root';

export const hermes = hermesApiRoot as HermesApiTyped;
